// ==== ==== ==== ==== ==== NY2023

const mobileSliderRootNode = document.getElementById('ny-banner-slider-container');
const mobileSliderImgNode = document.getElementById('ny-banner-slider-img');

const getAppedPoint = () => {
    const cl = mobileSliderRootNode.clientWidth;
    const sw = mobileSliderRootNode.scrollWidth;
    const result = (sw - cl - 1);
    return result;
};

const makeSliderNodeClear = () => {
    if (!mobileSliderRootNode) return;
    mobileSliderRootNode.childNodes.forEach((node) => {
        if (node.nodeName === '#text') {
            node.remove();
        }
    });
};


const removeExcessImgNode = () => {
    if (mobileSliderRootNode.childNodes.length === 4) {
        mobileSliderRootNode.firstChild.remove();
        mobileSliderRootNode.firstChild.remove();
    }
};


const movePeopleAnimation = () => {
    const { scrollLeft } = mobileSliderRootNode;
    removeExcessImgNode();
    const appendPoint = getAppedPoint();
    mobileSliderRootNode.scrollBy(1, 0);
    if (Math.round(scrollLeft) > appendPoint) {
        const newImgNode = mobileSliderImgNode.cloneNode(true);
        mobileSliderRootNode.appendChild(newImgNode);
    }
};

export function startNyAnimation(config) {
    const { pageId } = config;

    const pages = ['blyuda-dlya-novogodnego-stola', 'ny-sweets'];
    if (!pages.includes(pageId)) {
        return;
    }

    if (!mobileSliderRootNode) {
        return;
    }

    makeSliderNodeClear();

    setInterval(movePeopleAnimation, 30);
}

// ==== ==== ==== ==== ==== NY2023
